import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from './settings';
import { ResponseModel } from '../models/response-model';
import { ClienteModel } from '../models/cliente-model';


@Injectable({
  providedIn: 'root'
})
export class MailingService {

  constructor(private http: HttpClient) { }
  private rutaApi:string = AppSettings.apiEndpoint;
  private path:string = "";
  private produccion:boolean = AppSettings.produccion;


  async envMail(nro_cuenta:string, nro_cli: string, nro_prov: string, asunto:string,cuerpo:string,area:string) {
    if(asunto==null){ asunto=''; }
    if(cuerpo==null){ cuerpo=''; }
    if(nro_cuenta==null){ nro_cuenta=''; }
    if(nro_cli==null){ nro_cli=''; }
    if(nro_prov==null){ nro_prov=''; }
    if(area==null){area=''}
    if(asunto==='' || cuerpo ===''){ return new ResponseModel("1","Debe completar ambos campos"); }

      if(this.produccion){ this.path = this.rutaApi+'mailing.php';}
      else { this.path = '/api/mailing'; }

      const params={
        'cliente': nro_cuenta,
        'nro_proveedor': nro_prov,
        'nro_cliente': nro_cli,
        'login':'N',
        'asunto': asunto,
        'cuerpo' : cuerpo,
        'area': area}

       const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
       let response = await this.http.post<ResponseModel>(this.path,params,{headers}).toPromise();

    return response;
  }

  async consulCliente (nroCuenta:String) {
    if(nroCuenta==null){ nroCuenta=''; }

    if(this.produccion){ this.path = this.rutaApi+'consultar_datos_mailing.php';}
    else { this.path = '/api/consulCliente'; }

    const params={
      'cliente': nroCuenta,
      'login': 'N',
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
    let response = await this.http.post<any>(this.path,params,{headers}).toPromise();
    
        return  new ClienteModel(response[0].mail_venta, response[0].mail_prove, response[0].tel_venta, response[0].tel_prove);

  }
}
